import http from 'axios'
import { authApiURL as API_URL } from '../../utils'

const getProductTypes = ({ packageType = 'package', currency = 'EUR', dc = null }) => {
  const action = 'packageProductTypes'
  return http.get(API_URL, {
    params: {
      action,
      type: packageType,
      currency,
      dc: dc || null
    }
  }).then(res => res.data)
}

const getTransportTypes = ({ packageType = 'package', currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageTransportTypes',
    type: packageType,
    product: product || null,
    currency: currency || null,
    dc: dc || null
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

const getDeparturePoints = ({ packageType = 'package', transport = 'flight', date = null, destination = null, currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageDeparturePoints',
    type: packageType,
    transport,
    currency: currency || null,
    date: date || null,
    destination: destination || null,
    product: product || null,
    dc: dc || null
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

const getCountries = ({ packageType = 'package', transport = 'flight', departure = null, currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageCountries',
    type: packageType,
    transport,
    departure: departure || null,
    currency: currency || null,
    product: product || null,
    dc: dc || null
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

const getResorts = ({ packageType = 'package', transport = 'flight', departure = null, country, currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageResorts',
    type: packageType,
    transport,
    departure: departure || null,
    country,
    currency: currency || null,
    product: product || null,
    dc: dc || null
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const getAreas = ({ packageType = 'package', transport = 'flight', departure = null, resort, currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageAreas',
    type: packageType,
    transport,
    departure: departure || null,
    resort,
    currency: currency || null,
    product: product || null,
    dc: dc || null
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const getHotels = ({ packageType = 'package', destination, currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageHotels',
    type: packageType,
    destination,
    currency: currency || null,
    product: product || null,
    dc: dc || null
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const getDates = ({ packageType = 'package', transport = 'flight', departure = null, destination, currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageDates',
    type: packageType,
    transport,
    departure: departure || null,
    destination,
    currency: currency || null,
    product: product || null,
    dc: dc || null
  }
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const getDurations = ({ packageType = 'package', transport = 'flight', departure = null, destination, date, currency = 'EUR', dc = null, product = null }) => {
  const params = {
    action: 'packageDurations',
    type: packageType,
    transport,
    departure: departure || null,
    destination,
    date,
    currency: currency || null,
    dc: dc || null,
    product: product || null
  }
  return http.get(API_URL, { params: params }).then(res => res.data.map(el => el.duration))
}

const getSearchParams = ({ packageType = 'package', dc = null, product = null }) => {
  const params = {
    action: 'getPackageSearchParams',
    type: packageType,
    product_type: product,
    dc
  }
  return http.get(API_URL, { params }).then(res => res.data)
}

const getSearchResults = ({ packageType = 'package', dc = null, product = null, packageId = null }) => {
  const params = {
    action: 'getPackageSearchResults',
    type: packageType,
    product_type: product,
    dc
  }
  if (packageId !== null) params.id = packageId
  return http.get(API_URL, { params: params }).then(res => res.data)
}

const search = ({
  currency = 'EUR',
  packageType = 'package',
  transport = 'flight',
  departure,
  country,
  resort,
  area,
  airport,
  date,
  duration,
  hotels = null,
  category = null,
  rooms = [{ adults: 2, ages: [] }],
  // eslint-disable-next-line camelcase
  product_type = null,
  // eslint-disable-next-line camelcase
  only_available = false
}) => {
  const params = { product_type, currency, packageType, transport, departure, country, resort, area, airport, date, duration, hotels, category, rooms, only_available }
  const query = { action: 'runPackageSearch' }
  if (params.product_type) query.product_type = params.product_type
  return http.post(API_URL, params, { params: query })
    .then(res => res.data)
}

const paymentSchedule = ({
  packageType = 'package',
  product = null,
  result,
  pack,
  category,
  meal
}) => {
  const data = {
    result,
    package: pack,
    category: category,
    meal: meal
  }

  return http.post(API_URL, data, {
    params: {
      action: 'packagePaymentSchedule',
      type: packageType,
      product_type: product
    }
  })
    .then(res => res.data)
}

const book = ({
  packageType = 'package',
  product = null,
  result,
  pack,
  category,
  meal,
  pax,
  notes = '',
  status = 'confirmed',
  extras = [],
  client = {},
  insuranceEmail = null
}) => {
  const data = {
    result,
    package: pack,
    category: category,
    meal: meal,
    pax: pax,
    notes,
    status,
    client,
    extras,
    insuranceEmail
  }

  return http.post(API_URL, data, {
    params: {
      action: 'bookPackage',
      type: packageType,
      product_type: product || null
    }
  })
    .then(res => res.data)
}

export {
  getProductTypes,
  getTransportTypes,
  getSearchParams,
  getDeparturePoints,
  getCountries,
  getResorts,
  getAreas,
  getHotels,
  getDates,
  getDurations,
  getSearchResults,
  search,
  paymentSchedule,
  book
}
